import {useAuthUserStore} from "@/stores/auth";

export default {
    index() {
        return useAuthUserStore().getApiClient.get('/user/customer/credit-cart', )
    },
}